import type { ReactElement, ReactNode } from "react";
import { type CSSProperties } from "styled-components";
import { ToggleChip } from "src/design-system/components/Chip/ToggleChip";
import { RotatingChevron } from "src/svg/RotatingChevron";
import { HotelInputPicker } from "./HotelInputPicker";

type Props = {
  icon?: ReactElement;
  inputText?: string;
  label: string | ReactNode;
  ariaLabel: string;
  ariaExpanded: boolean;
  handleInputClick: () => void;
  placeholder?: string;
  id: string;
  onClickCta?: () => void;
  focusRef?: React.RefObject<HTMLButtonElement | null>;
  isChildExpanded?: boolean;
  pillBorderColor?: CSSProperties["color"];
  disabled?: boolean;
  disabledIcon?: ReactElement;
  handleClear?: () => void;
  hotelInput?: boolean;
  filterSelection?: string;
  isBlanketVisible?: boolean;
  onKeyDown?: (event: React.KeyboardEvent) => void;
};

export function ComboboxInput(props: Props) {
  const {
    icon,
    handleInputClick,
    label,
    ariaLabel,
    ariaExpanded,
    inputText,
    id,
    isChildExpanded,
    disabled,
    disabledIcon,
    handleClear,
    hotelInput,
    filterSelection,
    isBlanketVisible,
    onKeyDown,
  } = props;

  return (
    <>
      {hotelInput ? (
        <HotelInputPicker
          inputText={inputText}
          label={label}
          ariaLabel={ariaLabel}
          ariaExpanded={ariaExpanded}
          handleInputClick={handleInputClick}
          id={id}
          icon={icon}
        />
      ) : (
        <ToggleChip
          id={id}
          aria-label={ariaLabel}
          aria-expanded={ariaExpanded}
          onPress={handleInputClick}
          isSelected={!!isChildExpanded}
          isDisabled={disabled}
          disabledIcon={disabledIcon}
          handleClear={handleClear}
          onKeyDown={onKeyDown}
          filterSelection={filterSelection}
          icon={
            <RotatingChevron
              direction={isChildExpanded ? "up" : "down"}
              color={disabled ? "n40" : "black"}
            />
          }
          leftIcon={icon}
          isBlanketVisible={isBlanketVisible}
        >
          {filterSelection ? filterSelection : label}
        </ToggleChip>
      )}
    </>
  );
}
